import { create } from 'zustand';
import { WalletState, Asset, Transaction } from '../types';

// Mock data for demonstration
const mockAssets: Asset[] = [
  {
    id: 'algo',
    name: 'Algorand',
    symbol: 'ALGO',
    balance: 1250.75,
    value: 0.21,
    change24h: 5.2,
  },
  {
    id: 'usdc',
    name: 'USD Coin',
    symbol: 'USDC',
    balance: 500.00,
    value: 1.00,
    change24h: 0.1,
  },
  {
    id: 'arc200',
    name: 'ARC-200 Token',
    symbol: 'ARC',
    balance: 10000,
    value: 0.05,
    change24h: -2.3,
  },
];

const mockTransactions: Transaction[] = [
  {
    id: '1',
    type: 'receive',
    amount: 100,
    asset: 'ALGO',
    timestamp: new Date(Date.now() - 3600000),
    status: 'completed',
    from: 'ADDR...XYZ',
  },
  {
    id: '2',
    type: 'send',
    amount: 50,
    asset: 'USDC',
    timestamp: new Date(Date.now() - 7200000),
    status: 'completed',
    to: 'ADDR...ABC',
  },
  {
    id: '3',
    type: 'swap',
    amount: 200,
    asset: 'ALGO',
    timestamp: new Date(Date.now() - 86400000),
    status: 'completed',
  },
];

export const useWalletStore = create<WalletState>((set) => ({
  isConnected: false,
  address: null,
  balance: 0,
  assets: [],
  transactions: [],
  
  connect: async () => {
    // Mock connection - in real app, integrate with Pera Wallet or other Algorand wallets
    await new Promise(resolve => setTimeout(resolve, 1500));
    set({
      isConnected: true,
      address: 'ALGO7X2K4EXAMPLEWALLETADDRESS123456789ABCDEFGHIJKLMNOP',
      balance: 1750.75,
      assets: mockAssets,
      transactions: mockTransactions,
    });
  },
  
  disconnect: () => {
    set({
      isConnected: false,
      address: null,
      balance: 0,
      assets: [],
      transactions: [],
    });
  },
}));